module.exports = __webpack_public_path__ + "static/img/hiragana_large_ni-compressor.61c5dd8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/hiragana_large_ni-compressor.gif
// module id = An/Z
// module chunks = 0